
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type CreateConversation201LastMessageRole = typeof CreateConversation201LastMessageRole[keyof typeof CreateConversation201LastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateConversation201LastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
